import React from "react";
import { formatToken } from "../../utils/format";
import { TOKEN_SYMBOL } from "../../config/config";
import "./ClaimSection.css";

export default function ClaimSection({ claimable, onClaim, processing }) {
  const isZero = !claimable || claimable.isZero();

  return (
    <div className="claim-sec">
      <div className="claim-sec-balance">
        <span className="claim-sec-label">Available to Claim</span>
        <span className="claim-sec-value">{formatToken(claimable)} {TOKEN_SYMBOL}</span>
      </div>

      <button
        className="claim-sec-btn"
        onClick={onClaim}
        disabled={processing || isZero}
      >
        {processing ? "Processing..." : "Claim Now"}
      </button>
    </div>
  );
}
